import React from "react";
import Modal from "./Modal";

/**
 * DeleteFamilyModal - Confirmation modal for deleting a family
 */
const DeleteFamilyModal = ({
    isOpen,
    onClose,
    onSubmit,
    deletingFamilyId,
    families,
    deleteRuleSetsCheck,
    setDeleteRuleSetsCheck,
    saving
}) => {
    if (!isOpen || !deletingFamilyId) return null;

    const familyName = families.find(f => f.id === deletingFamilyId)?.name || "Unknown";

    return (
        <Modal isOpen={isOpen} onClose={onClose} overlayClassName="fade-in" contentStyle={{ maxWidth: '400px', padding: '1.25rem' }}>
            <h2 style={{ color: 'var(--error)' }}>Delete Family</h2>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: '1.4', marginBottom: '1rem' }}>
                Are you sure you want to delete family <strong>{familyName}</strong>?
            </p>
            <p style={{ background: 'rgba(220, 38, 38, 0.08)', borderLeft: '3px solid var(--error)', padding: '0.75rem', fontSize: '0.85rem', color: 'var(--error)', lineHeight: '1.4', marginBottom: '1rem' }}>
                <strong>Warning:</strong> Any local features defined only for this family will be permanently deleted. To save them, please convert them to global features in the feature scoping manager before deleting this family.
            </p>
            <form onSubmit={onSubmit}>
                <label className="modal-checkbox-row" style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start', cursor: 'pointer', userSelect: 'none' }}>
                    <input
                        type="checkbox"
                        checked={deleteRuleSetsCheck}
                        onChange={e => setDeleteRuleSetsCheck(e.target.checked)}
                    />
                    <span>
                        Permanently delete all rule tables associated with this family.
                        <br />
                        <em style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                            (If left unchecked, these tables will remain in the database and fall back to "Global / Domain Rules")
                        </em>
                    </span>
                </label>
                <div className="modal-actions" style={{ marginTop: '1.5rem' }}>
                    <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
                    <button type="submit" className="btn-primary" style={{ background: 'var(--error)', color: 'white', border: 'none' }} disabled={saving}>
                        {saving ? 'Deleting...' : 'Confirm Delete'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default DeleteFamilyModal;
